import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const CRM_VERSION = '1.0.0';

export function AppFooter() {
  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 2, md: 3 },
        py: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="caption" color="text.secondary">
        © {new Date().getFullYear()} HiveCore Communications Corporation — CRM Version{' '}
        {CRM_VERSION}
      </Typography>
    </Box>
  );
}
